import type { FilterField, FieldRow } from './types';

/**
 * Groups fields into rows based on their span property.
 * Fields with span=2 get their own row.
 * Fields with span=1 are grouped in pairs.
 *
 * @param fields - Array of filter fields
 * @returns Array of rows, where each row contains 1-2 fields
 *
 * @example
 * // Input: [span:2, span:1, span:1, span:2, span:1]
 * // Output: [[span:2], [span:1, span:1], [span:2], [span:1]]
 */
export function groupFieldsIntoRows(fields: FilterField[]): FieldRow[] {
    const rows: FieldRow[] = [];
    let currentRow: FilterField[] = [];

    for (const field of fields) {
        const span = field.span ?? 1; // Default to half-width

        if (span === 2) {
            // Full-width field: flush current row and add field in its own row
            if (currentRow.length > 0) {
                rows.push(currentRow);
                currentRow = [];
            }
            rows.push([field]);
        } else {
            // Half-width field: add to current row
            currentRow.push(field);

            // If row is full (2 fields), flush it
            if (currentRow.length === 2) {
                rows.push(currentRow);
                currentRow = [];
            }
        }
    }

    // Flush any remaining fields
    if (currentRow.length > 0) {
        rows.push(currentRow);
    }

    return rows;
}
